import { colorFor, initials } from "@/lib/avatars";

export function UserAvatar({ username, avatar, size = 40, showStatus = false, status = "online" }) {
  const dim = { width: size, height: size };
  const dot = size >= 40 ? "w-3 h-3" : "w-2.5 h-2.5";
  const statusColor =
    status === "online" ? "bg-emerald-500" : status === "idle" ? "bg-amber-500" : "bg-slate-500";

  return (
    <div className="relative shrink-0" style={dim}>
      {avatar ? (
        <img
          src={avatar}
          alt={username}
          className="w-full h-full rounded-xl object-cover border border-slate-300 dark:border-slate-700/60"
          style={dim}
        />
      ) : (
        <div
          className="w-full h-full rounded-xl flex items-center justify-center text-white font-bold"
          style={{ ...dim, backgroundColor: colorFor(username), fontSize: size * 0.38 }}
        >
          {initials(username)}
        </div>
      )}
      {showStatus && (
        <span className={`absolute -bottom-0.5 -right-0.5 ${dot} ${statusColor} rounded-full border-2 border-white dark:border-slate-900`} />
      )}
    </div>
  );
}
